<template>
  <div class="list-wrap">
    <template v-if="code !== 'abroadData'">
      <div class="list-item" v-for="item in contentList" :key="item.id">
        <div
          class="item-left"
          v-if="item.pictureFile && item.pictureFile.length !== 0"
        >
          <IconWrap
            :width="283"
            :height="164"
            :url="picUrl(item.pictureFile[0])"
          >
          </IconWrap>
        </div>
        <div class="item-right">
          <div class="title" @click="toDetails(item, code)">
            {{ item.title }}
          </div>
          <div class="content" v-html="item.brief"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <StaticTable></StaticTable>
    </template>
  </div>
</template>

<script>
import commonDetail from '@/views/MIndex/mixin/index'
import StaticTable from './staticTable.vue'
export default {
  props: {
    contentList: Array,
    tag: String,
    code: {
      type: String,
      default: 'fxbg'
    },
    selectedId: {
      type: [Number, String],
      default: '1'
    },
  },
  components: { StaticTable },
  mixins: [commonDetail],
  data() {
    return {}
  },
  methods: {
    picUrl(val) {
      if (val) {
        const baseUrl = process.env.VUE_APP_BASE_IMGURL
        return baseUrl + val.filePath
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
